import moment from 'moment'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.filter('formatJourLivraison', function(value: Date,i18n:VueI18n,utc:boolean=false) {
  if (value) {
    moment.locale(i18n?.locale??"fr")    
    const date = utc?moment(String(value)).utc():moment(String(value))
    
    const today = new Date()    
    today.setHours(0,0,0,0)
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    tomorrow.setHours(0,0,0,0)
    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)
    yesterday.setHours(0,0,0,0)

    if(moment(String(yesterday)).format("YYYY-MM-DD") == date.format("YYYY-MM-DD")) return i18n.t('Global.Yesterday').toString()
    else if(moment(String(tomorrow)).format("YYYY-MM-DD") == date.format("YYYY-MM-DD")) return i18n.t('Global.Tomorrow').toString()
    else if(moment(String(today)).format("YYYY-MM-DD") == date.format("YYYY-MM-DD")) return ""
    return date.format("DD/MM/YYYY")
  }
})